export default __webpack_public_path__ + "static/media/microphone.3f0bfc28.svg";